import { Controller } from "@hotwired/stimulus";

// This replicates the validation in HasSlug. We need to manually
// keep the rules in sync.
export default class extends Controller {
  connect() {
    this.inputField = this.element.querySelector("input");
    this.inputField.addEventListener("input", this.handler.bind(this));
    this.inputField.addEventListener("change", this.handler.bind(this));
    this.slugValue = this.element.querySelector("slug-value");
    this.hint = this.element.querySelector(".hint");
  }

  disconnect() {
    this.inputField.removeEventListener("input", this.handler);
    this.inputField.removeEventListener("change", this.handler);
    this.clearTimeout();
  }

  handler(e) {
    const separator = "-";
    const origValue = e.target.value;
    let value = origValue;

    // Replace any invalid characters with separator
    value = value.replace(/[^a-z0-9\-_]/gi, separator);

    // Must start with a letter or underscore
    value = value.replace(/^[^a-z_]/i, "_$&");

    // Apply the changes
    e.target.value = value;

    // If the value was changed then highlight the rules in the hint
    // for a second.
    if (value != origValue) {
      this.hint.classList.add("reminder");
      this.clearTimeout();
      this.timeout = setTimeout(() => {
        this.hint.classList.remove("reminder");
      }, 1000);
    }

    // Update the preview of the URL if there is one
    if (this.slugValue) {
      this.slugValue.innerText = value;
    }
  }

  clearTimeout() {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  }
}
